import { useMemo } from "react";
import { MaterialReactTable, type MRT_ColumnDef } from "material-react-table";
import { IconButton } from "@mui/material";
import { Edit, Delete, Replay } from "@mui/icons-material";
import { LocationListData, Props } from "../../../types/types";
import { Box } from "@mui/material";

const AddLocationTable = ({ locationData, onEdit, onDelete }: Props) => {
  // Memoized columns with dependency array
  const columns = useMemo<MRT_ColumnDef<LocationListData>[]>(
    () => [
      {
        accessorKey: "locationName",
        header: "Location Name",
        size: 150,
      },
      {
        accessorKey: "className",
        header: "Location Class Name",
        size: 200,
      },
      {
        accessorKey: "businessStreet1",
        header: "Street Address",
        size: 150,
      },
      {
        accessorKey: "businessCity",
        header: "City",
        size: 150,
      },
      {
        accessorKey: "businessPhone",
        header: "Phone Number",
        size: 150,
      },
      {
        id: "actions",
        header: "Actions",
        Cell: ({ row }) => (
          <div>
            {!!row.original.deletedOn ? (
              <IconButton sx={{ padding: 0 }}>
                <Replay className="deleteicon" />
              </IconButton>
            ) : (
              <>
                <IconButton
                  onClick={() => onEdit(row.original.id)}
                  sx={{ padding: 0 }}
                  color="primary"
                >
                  <Edit />
                </IconButton>
                <IconButton
                  onClick={() => onDelete(row.original.id)}
                  sx={{ padding: 0, marginLeft: 1 }}
                >
                  <Delete className="deleteicon" />
                </IconButton>
              </>
            )}
          </div>
        ),
      },
    ],
    [onEdit, onDelete]
  );

  return (
    <div>
      <MaterialReactTable
        columns={columns}
        data={locationData}
        enableDensityToggle={true}
        enableHiding={true}
        enableColumnFilters={true}
        enableGlobalFilter={true}
        enableFullScreenToggle={true}
        enableColumnActions={true}
        initialState={{
          showColumnFilters: false,
          showGlobalFilter: true,
        }}
        positionGlobalFilter="left"
        renderTopToolbarCustomActions={() => (
          <Box sx={{ display: "flex", gap: 2, p: 1 }}>
          </Box>
        )}
        muiSearchTextFieldProps={{
          placeholder: "Search locations...",
          sx: { minWidth: "300px" },
          variant: "outlined",
          size: "small",
        }}
        muiTableHeadCellProps={{
          sx: {
            backgroundColor: "#f5f5f5",
            fontWeight: 600,
          },
        }}
        muiTableBodyRowProps={{
          hover: true,
        }}
        muiTablePaperProps={{
          sx: {
            "& .MuiTable-root": {
              "& .MuiTableBody-root": {
                "& .MuiTableRow-root": {
                  "&:nth-of-type(odd)": {
                    backgroundColor: "white",
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "#f5f5f5",
                  },
                },
              },
            },
          },
        }}
      />
    </div>
  );
};

export default AddLocationTable;
